import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { Result } from "../models/common/resultResponse";
import { PositionResponse } from "../models/response";
import { IPositionApi } from "./base/partPositionApi";
import { PositionRequest } from "../models/request/positionRequest";

const baseRoute: string = "PartPosition";

export class PositionApi extends IPositionApi {
	getPosition(request: PositionRequest): Promise<AxiosResponse<Result<PositionResponse[]>>> {
		return api.get(`${baseRoute}/getpositionsbypartguid`, { params: request });
	}

	getPositionWithIdPIES(request: PositionRequest): Promise<AxiosResponse<Result<PositionResponse[]>>> {
		return api.get(`${baseRoute}/getpositionswithidpiesbypartguid`, {
			params: request,
		});
	}
}
